module.exports = __webpack_public_path__ + "static/media/joseph.939a6494.jpg";